











































































import Vue from "vue";
import Component from "vue-class-component";
import { formatImageUrl } from "@/common/utils";
import { Prop } from "vue-property-decorator";
import { MeService as meApi } from "@/common/api";
import QErrors from "@/common/qErrors.vue";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const noImage = require("@/assets/images/muuq-base/noimage.png");
@Component({
  name: "GroupItem",
  components: {
    QErrors,
  },
})
export default class GroupItem extends Vue {
  @Prop({
    default: () => [],
  })
  group: any;

  form: any = {
    comment: "",
    groupId: null,
  };

  showFollowRequest = false;

  requestComment = "";

  errors = {};

  get groupImage() {
    return this.group.image
      ? formatImageUrl(this.group.image.name, "640x427", "contain")
      : noImage;
  }

  follow() {
    if (this.group.followStatus) {
      return;
    }

    if (this.group.requestApproved) {
      this.requestComment = "";
      this.errors = {};
      this.showFollowRequest = true;
    } else {
      this.doFollow();
    }
  }

  async doFollow() {
    let result;
    try {
      result = await meApi.meFollow({
        groupId: this.group.id,
        comment: this.requestComment,
      });
    } catch (error) {
      result = error.body;
    }

    if (result.status === "error") {
      this.$notify({
        text: result.message,
      });
      this.errors = result.errors;
    } else {
      this.group.followStatus = this.group.requestApproved ? "wait" : "follow";
      this.group.followingMembersCount += 1;
      this.showFollowRequest = false;
    }
  }
}
